/* Face Dunk - Dan Site refresh (small storefront helpers) */
(function () {
  if (window.__FD_DAN_JS__) return;
  window.__FD_DAN_JS__ = true;

  /* ---------- Sticky Add to cart on product pages ----------
     Shows the sticky bar as soon as the main Add to cart button
     has scrolled out of view (instead of waiting for the end of the
     whole product block). */
  function initStickyAtc() {
    var bar = document.querySelector('.satc');
    var atc = document.getElementById('fd-atc');
    if (!bar || !atc || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 });
    io.observe(atc);
    bar.classList.add('fd-satc-managed');
  }

  /* ---------- Bundle check right before checkout ----------
     Runs the bundle integrity repair on the real cart content before
     leaving for checkout. If the cart had to be corrected, the customer
     stays on the cart and sees the corrected prices first. */
  var CHECKOUT_SEL = '[data-fd-checkout-form] [type="submit"], button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href$="/checkout"]';
  var checking = false;

  function cartSignature(c) {
    if (!c || !c.items) return '';
    return c.items.map(function (i) {
      return i.key + ':' + i.quantity + ':' + (i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.id : '0');
    }).join('|') + '#' + c.total_price;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest(CHECKOUT_SEL);
    if (!trigger || trigger.dataset.fdVerified === '1' || typeof window.fdBundleRepairNow !== 'function') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checking) return;
    checking = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (before) {
        return window.fdBundleRepairNow().then(function (after) {
          if (cartSignature(before) !== cartSignature(after)) {
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: after } }));
            if (/\/cart\/?$/.test(location.pathname)) location.reload();
            return;
          }
          location.href = root + 'checkout';
        });
      })
      .catch(function () { location.href = root + 'checkout'; })
      .finally(function () { checking = false; });
  }, true);

  /* Also check the cart once on every page load, so a bundle changed
     outside the theme (another tab, a direct cart link) is corrected
     as soon as the customer sees any page. */
  function initialBundleCheck() {
    if (typeof window.fdBundleRepairNow !== 'function') return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (before) {
        if (!before.items || !before.items.some(function (i) { return i.properties && i.properties['_FD Bundle']; })) return;
        return window.fdBundleRepairNow().then(function (after) {
          if (cartSignature(before) !== cartSignature(after) && /\/cart\/?$/.test(location.pathname)) location.reload();
        });
      })
      .catch(function () {});
  }

  /* Cart page: list free subscription gifts after the paid products
     (same order as the cart drawer). Re-applied when the cart re-renders. */
  function giftsLast() {
    var body = document.querySelector('cart-items tbody, .cart-items tbody');
    if (!body) return;
    var apply = function () {
      /* already in order when no paid row comes after a gift row */
      if (!body.querySelector(':scope > tr.fd-gift-row ~ tr:not(.fd-gift-row)')) return;
      body.querySelectorAll(':scope > tr.fd-gift-row').forEach(function (row) { body.appendChild(row); });
    };
    apply();
    new MutationObserver(function () {
      var b = document.querySelector('cart-items tbody, .cart-items tbody');
      if (b && b !== body) { body = b; }
      apply();
    }).observe(document.querySelector('cart-items') || body, { childList: true, subtree: true });
  }

  /* Product page: start with The Glow Starter selected (as in the mockup),
     so the Subscribe line shows its monthly price straight away. */
  function preselectStarter() {
    var root = document.querySelector('[data-custom-bundles]');
    if (!root || window.fdSelectedCustomBundle) return;
    /* ?bundle=3 (from the Shop All Trio card) opens that bundle as a subscription */
    var wanted = '';
    try { wanted = (new URLSearchParams(location.search).get('bundle') || '').replace(/[^0-9]/g, ''); } catch (e) {}
    var target = wanted ? root.querySelector('[data-bundle-card="' + wanted + '"] .fdcb-summary') : null;
    var first = target || root.querySelector('[data-bundle-card="1"] .fdcb-summary') || root.querySelector('[data-bundle-card] .fdcb-summary');
    if (first) first.click();
    if (target) {
      var sub = root.querySelector('[data-global-purchase-option="subscription"]');
      if (sub && !sub.classList.contains('is-selected')) sub.click();
    }
  }

  /* ---------- Essentials offer for subscribers ----------
     The card is rendered hidden in the cart drawer and on the cart page.
     It is shown when the cart holds a subscription and no Essentials yet.
     The discounted price itself is applied by Shopify (automatic discount),
     so removing the subscription brings the Essentials back to full price. */
  function initEssentials() {
    var offers = [].slice.call(document.querySelectorAll('[data-fd-ess-offer]'));
    if (!offers.length) return;
    var essId = Number(offers[0].dataset.productId);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var timer = null;

    function evaluate(cart) {
      var items = (cart && cart.items) || [];
      var hasSub = items.some(function (i) { return i.selling_plan_allocation && i.product_id !== essId; });
      var hasEss = items.some(function (i) { return i.product_id === essId; });
      var show = hasSub && !hasEss;
      offers.forEach(function (o) { o.hidden = !show; });
      document.documentElement.classList.toggle('fd-ess-on', show);
      window.fdEssInCart = hasEss;
      [].forEach.call(document.querySelectorAll('[data-fd-ess-note]'), function (n) {
        n.hidden = hasEss;
        var c = n.querySelector('[data-fd-ess-check]');
        if (c && hasEss) c.checked = false;
      });
    }
    function refresh() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.json(); }).then(evaluate).catch(function () {});
      }, 350);
    }

    /* follow every cart change made by the theme or the apps */
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch.apply(window, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(refresh, refresh);
      return p;
    };
    document.addEventListener('cart:refresh', refresh);

    document.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('[data-fd-ess-add]');
      if (!btn || btn.disabled) return;
      var card = btn.closest('[data-fd-ess-offer]');
      btn.disabled = true;
      nativeFetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(card.dataset.variantId), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          if (card.dataset.context === 'page') { location.reload(); return; }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(function () {})
        .finally(function () { btn.disabled = false; });
    });

    refresh();
  }

  /* ---------- Cart page always shows the real cart ----------
     When a bundle drop is removed, the bundle check removes its free gifts
     right after the page has redrawn, which could leave the gift rows on
     screen. After every cart change, compare what the page shows with the
     real cart and reload the page when they differ. */
  function initCartPageSync() {
    if (!/\/cart\/?$/.test(location.pathname)) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var timer = null;
    function shown() {
      var map = {};
      document.querySelectorAll('cart-items input[name="updates[]"], .cart-items input[name="updates[]"]').forEach(function (i) {
        var v = i.getAttribute('data-quantity-variant-id') || i.id;
        map[v] = (map[v] || 0) + (parseInt(i.value, 10) || 0);
      });
      return map;
    }
    function check() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var go = typeof window.fdBundleRepairNow === 'function'
          ? window.fdBundleRepairNow()
          : fetch(root + 'cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
        Promise.resolve(go).then(function (cart) {
          if (!cart || !cart.items) return;
          var real = {};
          cart.items.forEach(function (it) { real[it.variant_id] = (real[it.variant_id] || 0) + it.quantity; });
          var page = shown();
          var keys = Object.keys(real).concat(Object.keys(page));
          var differ = keys.some(function (k) { return (real[k] || 0) !== (page[k] || 0); });
          if (!differ) return;
          /* never more than 2 reloads in 20 seconds */
          var now = Date.now(), log = [];
          try { log = JSON.parse(sessionStorage.getItem('fdCartSync') || '[]').filter(function (t) { return now - t < 20000; }); } catch (e) {}
          if (log.length >= 2) return;
          log.push(now);
          try { sessionStorage.setItem('fdCartSync', JSON.stringify(log)); } catch (e) {}
          location.reload();
        }).catch(function () {});
      }, 1600);
    }
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch.apply(window, arguments);
      if (/\/cart\/(change|update|add)/.test(url)) p.then(check, check);
      return p;
    };
  }

  function init() {
    initCartPageSync();
    initEssentials();
    preselectStarter();
    initStickyAtc();
    initialBundleCheck();
    giftsLast();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
